import { Box, Stack } from '@mui/material';
import { Link as RouterLink, Outlet } from 'react-router';
import { BrandLogo } from '@/components/brand/BrandLogo';
import { ColorModeToggle } from '@/components/ColorModeToggle';

/** Minimal frame for the legal pages on hosts without a public layout. */
export function LegalShell() {
  return (
    <Box sx={{ minHeight: '100dvh' }}>
      <Stack
        direction="row"
        sx={(theme) => ({
          px: 2,
          py: 1.5,
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: `1px solid ${theme.vars.palette.divider}`,
        })}
      >
        <Box component={RouterLink} to="/" sx={{ color: 'inherit', textDecoration: 'none' }}>
          <BrandLogo size="small" />
        </Box>
        <ColorModeToggle />
      </Stack>
      <Outlet />
    </Box>
  );
}
